import { useEffect, useState, useRef } from "react";
import { React } from "react-router-dom";
import copy from "copy-to-clipboard";

export default function InfoButton({uuid, tags, date})
{
  const [cssClass, setCSSClass] = useState(['info_button']);
  const [hovered, setHovered] = useState(false);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
  }, []);

  useEffect(() => {
    const updateCSSClass = () => {
      var complete_class = "info_button";
  
      if (hovered) {
        complete_class += " info_button_hovered";
      }
  
      setCSSClass(complete_class);
    };

    updateCSSClass();
  }, [hovered]);

  const hMouseEnter = () => { setHovered(true); }
  const hMouseLeave = () => { setHovered(false); }
  const hMouseDown = () => { setSelected(!selected); }

  const hHaltPropagation = (event) => {event.stopPropagation();}

  function displayTags()
  {
    return(
      <ul>
        {tags.split(' ').map((tag, idx) => (<li key={idx}>{tag}</li>))}
      </ul>
    );
  }

  function displayInfoBlock()
  {
    if (selected){
      return (
      <div 
      onMouseEnter={hHaltPropagation} 
      onMouseLeave={hHaltPropagation}
      onMouseDown={hHaltPropagation}
      className="info_button_info_box">
        <div className="info_button_info_box_date">{date}</div>
        <div className="info_button_info_box_uuid">{uuid}</div>
        <div className="info_button_info_box_tags">{displayTags()}</div>
        </div>
      );
    }
  }

  return (
    <div
    onMouseEnter={hMouseEnter} 
    onMouseLeave={hMouseLeave} 
    onMouseDown={hMouseDown}
    className={cssClass}
    >i
    {displayInfoBlock()}
    </div>
  );
}